import * as R from 'ramda'

export const notEqBy = R.complement(R.eqBy)
